// Shingle manufacturers and their product lines.
//
// Suggestions, not a closed set — both fields accept free text, so a line that
// isn't here (or a brand we've never used) can still be typed. Worth having Trey
// confirm and prune this list; it's assembled from each manufacturer's common
// residential range rather than from anything Pro Roofers actually stocks.
//
// Terminology, because three similar things are in play:
//   brand   — the manufacturer (Owens Corning)
//   line    — the product line (Duration). Labelled "Shingle Type" in the UI,
//             which is what Trey asked for.
//   profile — Architectural / 3-Tab / Luxury / Premium. This is the field the
//             backend calls ShingleType, kept under its old name so existing rows
//             and automation conditions stay valid.
export const SHINGLE_BRANDS = [
  {
    brand: 'Owens Corning',
    lines: ['Oakridge', 'TruDefinition Duration', 'Duration Designer', 'Duration Storm',
            'Duration Flex', 'Berkshire', 'Woodmoor', 'Woodcrest', 'Devonshire', 'Supreme'],
  },
  {
    brand: 'CertainTeed',
    lines: ['Landmark', 'Landmark Pro', 'Landmark Premium', 'Landmark Solaris',
            'Carriage House', 'Grand Manor', 'Presidential Shake', 'Highland Slate',
            'Belmont', 'XT 25', 'XT 30'],
  },
  {
    brand: 'GAF',
    lines: ['Timberline HDZ', 'Timberline UHDZ', 'Timberline AS II', 'Timberline CS',
            'Grand Sequoia', 'Grand Canyon', 'Camelot II', 'Slateline', 'Woodland',
            'Royal Sovereign', 'Marquis WeatherMax'],
  },
  {
    brand: 'Atlas',
    lines: ['Pinnacle Pristine', 'StormMaster Shake', 'StormMaster Slate', 'GlassMaster'],
  },
  {
    brand: 'TAMKO',
    lines: ['Heritage', 'Heritage Woodgate', 'Titan XT', 'Elite Glass-Seal'],
  },
  {
    brand: 'IKO',
    lines: ['Cambridge', 'Dynasty', 'Nordic', 'Armourshake', 'Crowne Slate'],
  },
  {
    brand: 'Malarkey',
    lines: ['Highlander', 'Vista', 'Legacy', 'Windsor', 'Ecoasis'],
  },
];

export const SHINGLE_BRAND_NAMES = SHINGLE_BRANDS.map(b => b.brand);

// Lines for one brand. With no brand chosen (or an unrecognised one), every line
// is offered rather than none — a half-filled job shouldn't lose its suggestions.
export const shingleLinesFor = (brand) => {
  const match = SHINGLE_BRANDS.find(b => b.brand.toLowerCase() === String(brand || '').trim().toLowerCase());
  return match ? match.lines : SHINGLE_BRANDS.flatMap(b => b.lines);
};

// Profile / cut of the shingle. Was the entire "Shingle Type" dropdown before the
// brand and line fields existed.
export const SHINGLE_PROFILES = ['Architectural', '3-Tab', 'Luxury', 'Premium'];
